export { setBeaconPageViewed, setBeaconRoute, openBeacon } from './beaconHooks'
export type { FormObject } from './beaconHooks'
